// withViewport - independant withBreakpointRange with viewport
import { debounce } from 'lodash';
import { Component as ReactComponent } from 'react';

import { getBreakpointRange } from '@mews-distributor/common';

const RESIZE_DEBOUNCE = 200;

const getViewport = () => ({
    height: window.innerHeight,
    width: window.innerWidth,
});

export const withViewport = (Component: $TSFixMe) =>
    class extends ReactComponent {
        constructor(props: $TSFixMe) {
            super(props);
            this.state = {
                breakpointRange: getBreakpointRange(),
                viewport: getViewport(),
            };
            window.addEventListener('resize', this.handleResize);
        }

        componentWillUnmount() {
            window.removeEventListener('resize', this.handleResize);
        }

        handleResize = debounce(() => {
            this.setState({
                breakpointRange: getBreakpointRange(),
                viewport: getViewport(),
            });
        }, RESIZE_DEBOUNCE);

        render() {
            return <Component {...this.state} {...this.props} />;
        }
    };
